import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_ALLOCATION_TEST = defineFcm('petition_page_allocation_test')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Petition Page',
		description:
			'Runtime toggle for the petition_page_allocation_test experiment, a no-op A/B test used to validate that the Experiment Service buckets users evenly across control, fake_control, variant_1, and variant_2.',
		import: false,
		template: { enabled: true },
	});
